import React from "react";
import { RadioGroup } from "components/Atoms/inputs/RadioGroup";

interface Props {
  row: server.dto.AdvancingTemplateRow
  onChange: (advancingChunkId: string, behavior: server.dto.FormElementBehaviors) => void
}

export default class TemplateEditItem extends React.Component<Props> {
  onRadioButtonClicked = (behavior: server.dto.FormElementBehaviors) => {
    this.props.onChange(this.props.row.advancingChunkId, behavior);
  };

  public render(): JSX.Element {
    const { row } = this.props;

    const radioOptions: { label: string, value: server.dto.FormElementBehaviors }[] = [
      { label: RESX.Advancing.Hidden, value: "notVisible" },
      { label: RESX.Advancing.ReadOnly, value: "disabled" },
      { label: RESX.Advancing.Optional, value: "visibleOptional" },
      { label: RESX.Advancing.Required, value: "visibleMandatory" }
    ];

    return <>
      <div style={{ width: "100%" }}>
        <div className="margin-bottom-small">{row.label}</div>
        <div className="s1_gray">{row.sublabel}</div>
      </div>
      <RadioGroup
        wrapperClassName="advancing-template-row-radio"
        orientation="horizontal"
        options={radioOptions}
        value={row.formElementBehavior}
        onChange={this.onRadioButtonClicked}
      />
    </>;
  }
}
